import { useState, useEffect } from "react";

const useSkillSetText = (skillsArr) => {
  const [skillset, setSkillset] = useState("");

  useEffect(() => {
    // Function to run
    const buildSkillsetString = () => {
      let skillsStr = "unspecified, ";

      // Filter out skills with "undefined" value
      const filteredSkills = skillsArr.filter((skill) => skill.skill !== "undefined");

      // Loop over the filtered array
      filteredSkills.forEach((skillsArr) => {
        if (skillsArr.skill !== "") {
          if (skillsStr === "unspecified, ") {
            skillsStr = `${skillsArr.skill}, `;
          } else {
            skillsStr += `${skillsArr.skill}, `;
          }
        }
      });

      skillsStr = skillsStr.slice(0, -2);
      return skillsStr;
    };

    if (skillsArr !== undefined) {
      setSkillset(buildSkillsetString());
    }
  }, [skillsArr]);

  return skillset;
};

export default useSkillSetText;
